(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dtzz18-product-card-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('mouseover', function(event) {
    const swatch = event.target.closest('[data-swatch-image]');
    if (!swatch) return;

    const card = swatch.closest('.dtzz18-product-card');
    if (!card) return;

    const primaryImg = card.querySelector('.dtzz18-product-card__primary img');
    if (!primaryImg) return;

    const newSrc = swatch.getAttribute('data-swatch-image');
    if (newSrc) {
      primaryImg.setAttribute('src', newSrc);
      primaryImg.setAttribute('srcset', '');
    }

    const swatches = card.querySelectorAll('.dtzz18-card-swatches__swatch');
    swatches.forEach(function(s) { s.classList.remove('dtzz18-card-swatches__swatch--active'); });
    swatch.classList.add('dtzz18-card-swatches__swatch--active');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dtzz18-toast"] && !Shopify.designMode) return;
  try {
    class Dtzz18Toast extends HTMLElement {
    connectedCallback() {
      this.messageEl = this.querySelector('[data-ref="toast-message"]');
      this.closeBtn = this.querySelector('[data-ref="toast-close"]');
      this.timeout = null;

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.hide());
      }

      /* Global API */
      window.Dtzz18Toast = {
        show: (msg, type, duration) => this.show(msg, type, duration),
        hide: () => this.hide()
      };
    }

    show(msg, type, duration) {
      if (!this.messageEl) return;
      var ms = duration || 4000;
      this.messageEl.textContent = msg;
      this.style.setProperty('--toast-duration', ms + 'ms');
      this.className = 'dtzz18-toast dtzz18-toast--visible';
      if (type) this.classList.add('dtzz18-toast--' + type);

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.hide(), ms);
    }

    hide() {
      this.classList.remove('dtzz18-toast--visible');
      clearTimeout(this.timeout);
    }
  }

  if (!customElements.get('dtzz18-toast')) {
    customElements.define('dtzz18-toast', Dtzz18Toast);
  }
  } catch(e) { console.error(e); }
})();

})();
